import React from "react";
import TypelessVector from './TypelessVector.tsx';
import HazardPointers from './HazardPointers.tsx';

export interface BlogProps {
    id: String,
    title: String,
    summary: String
}

export const posts: {
    id: String,
    title: String,
    summary: String,
    component: React.FC
}[] = [
        {
            id: "Typeless Vector",
            title: "Typeless Vector",
            summary: "A humble type-erased vector implementation",
            component: TypelessVector
        },
        {
            id: "Hazard Pointers",
            title: "Hazard Pointers",
            summary: "Hazard Pointers: What I Learned While Fixing Memory Reclamation in Lock-Free C++",
            component: HazardPointers
        }
    ];